export default class YotpoHeader extends HTMLElement {
	constructor() {
		super();

		this.init();
	}

	reviewPagesGotten = [];

	reviewData = [];

	async init() {
    // Apply helper classes, plus watch for changes
    this.yotpoMutationObserver(async () => {
			const activePage = document.querySelector("[page].selected")?.innerHTML;
			if (activePage) {
				// Data already in array
				if (this.reviewPagesGotten.indexOf(activePage) != -1) {
					this.addReviewClasses();
				// Get new data
				} else {
					this.reviewPagesGotten.push(activePage);
					const reviewData = await this.getReviewsDataByPage(activePage);

					this.reviewData = [...this.reviewData, ...reviewData.reviews];

					this.addReviewClasses();
				}
			}
    });
	}

	async getReviewsDataByPage(page = '1') {
		const response = await fetch(
			// // `https://api-cdn.yotpo.com/v1/widget/${this.dataset.appKey}/products/${this.dataset.productId}/reviews.json?per_page=150`,
			`https://api-cdn.yotpo.com/v3/storefront/store/${this.dataset.appKey}/product/${this.dataset.productId}/reviews?page=${page}&perPage=5&sort=date,images,badge,rating`,
			{
				headers: {
					"Content-Type": "application/json",
					// 'Content-Type': 'application/x-www-form-urlencoded',
				},
			}
		);
		const reviewData = await response.json();
		return reviewData;
	}

	addReviewClasses() {
		this.reviewData.map((review) => {
			const reviewRow = document.querySelector(
				`[data-id="${review.id}"]`
			);
			if (
				!!reviewRow &&
				review.isIncentivized &&
				review.incentiveType == "other"
			) {
				reviewRow?.classList.add("review--is-incentivized");
			}
		});
	}

	yotpoMutationObserver(changed = () => {}) {
		const targetNodes = document
			.querySelectorAll(".shopify-app-block");

		targetNodes.forEach((targetNode) => {
			if (!targetNode.querySelector(".yotpo-widget-instance")) return;

			// Callback function to execute when mutations are observed
			const callback = (mutationList, observer) => {
				for (const mutation of mutationList) {
					if (mutation.type === "childList") {
						changed();
					} else if (mutation.type === "attributes") {
						// 	`The ${mutation.attributeName} attribute was modified.`
						// );
						// changed();
					}
				}
			};

			// Create an observer instance linked to the callback function
			const observer = new MutationObserver(callback);

			// Start observing the target node for configured mutations
			observer.observe(targetNode, {
				attributes: true,
				childList: true,
				subtree: true,
			});
		});
	}
}
